const feedbackEndpoint =
  "https://getform.io/f/9d34a314-1d02-4ea7-b2fb-dfde1dcf123c"

export function sendFeedbackForm(
  params,
  { captchaToken, captchaAction, captchaUserId } = {}
) {
  return fetch(feedbackEndpoint, {
    mode: "cors",
    method: "post",
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
      "X-Recaptcha-Token": captchaToken,
      "X-Recaptcha-Action": captchaAction,
      "X-Recaptcha-UserId": captchaUserId,
    },
    body: JSON.stringify(params),
  })
}

const careersEndpoint =
  "https://getform.io/f/daf4b0ae-5fe2-46e8-bd70-871c5fba56b5"

export function sendCareersForm(
  params,
  { captchaToken, captchaAction, captchaUserId } = {}
) {
  return fetch(careersEndpoint, {
    mode: "cors",
    method: "post",
    headers: {
      "X-Recaptcha-Token": captchaToken,
      "X-Recaptcha-Action": captchaAction,
      "X-Recaptcha-UserId": captchaUserId,
    },
    body: params,
  })
}

const newsletterApiBase = process.env.GATSBY_NEWSLETTER_API_BASE

export function sendNewsletterForm({
  name,
  email,
  dateOfBirth,
  market,
  language,
  captchaToken,
  captchaAction,
  captchaUserId,
}) {
  return fetch(
    `${newsletterApiBase}/api/ciss/forms/burger-king-newsletter/subscribe`,
    {
      mode: "cors",
      method: "post",
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
        "X-Recaptcha-Token": captchaToken,
        "X-Recaptcha-Action": captchaAction,
        "X-Recaptcha-UserId": captchaUserId,
      },
      body: JSON.stringify({
        name,
        email,
        dateOfBirth,
        consented: true,
        market,
        language,
      }),
    }
  ).then((response) => {
    if (!response.ok) throw new Error(response.status)
    return response
  })
}

export function sendUnsubscribeForm({
  email,
  captchaToken,
  captchaAction,
  captchaUserId,
}) {
  return fetch(
    `${newsletterApiBase}/api/ciss/forms/burger-king-newsletter/unsubscribe`,
    {
      mode: "cors",
      method: "post",
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
        "X-Recaptcha-Token": captchaToken,
        "X-Recaptcha-Action": captchaAction,
        "X-Recaptcha-UserId": captchaUserId,
      },
      body: JSON.stringify({ email }),
    }
  ).then((response) => {
    if (!response.ok) throw new Error(response.status)
    return response
  })
}
